var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height d-flex flex-column white"},[_c('AppBar',{attrs:{"to-page":_vm.toPage,"color":"primary","dark":"","disable-help":"","disable-lang":"","disable-menu":false}}),_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }